import { useQuery } from 'react-query';
import { useFutureOrderStore } from '../components/Stores/FutureOrdersStore';
import { useAccountStore } from '../components/Stores/accountStore';
import { getAllFutureOrdersByAccount, getFutureOrderById } from '../sp-firebase/futureOrderFB';
import { StatusType } from '../sp-types/statusType';
import { useCallback } from 'react';

export const useFutureOrders = (statusTypes: StatusType[] = ['completed']) => {
  const { setAllFutureOrders, setIsFutureOrdersLoading } = useFutureOrderStore();
  const { account } = useAccountStore();

  const fetchFunction = useCallback(() => {
    setIsFutureOrdersLoading(true);

    return getAllFutureOrdersByAccount(account.id || '', statusTypes);
  }, [account.id, statusTypes]);

  return useQuery(['Future-Orders', account.id], fetchFunction, {
    onSuccess: (data) => {
      if (data) {
        setAllFutureOrders(data);
      }
      setIsFutureOrdersLoading(false);
    },
    onError: (error) => {
      setIsFutureOrdersLoading(false);

      console.error('Error fetching future orders:', error);
    },
    enabled: false, //!!account.id,
  });
};

export const useSpecificFutureOrder = (futureOrderId?: string) => {
  const enable = futureOrderId !== undefined && futureOrderId !== '';
  const fetchFunction = () => getFutureOrderById(futureOrderId || '');
  return useQuery('future-order', fetchFunction, {
    enabled: enable,
    refetchOnWindowFocus: false,
  });
};
